import React, { createContext, useState, useEffect, memo } from 'react';

const MINUTE_MS = 60_000;

export const TimerContext = createContext(new Date());

const TimerProviderComponent = ({ children }) => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    // Calculate milliseconds remaining until the next full minute (XX:XX:00).
    const msUntilNextMinute = MINUTE_MS - (Date.now() % MINUTE_MS);
    let intervalId = null;

    // Wait until the clock hits :00 seconds, then start a perfectly synced interval.
    const timeoutId = setTimeout(() => {
      setNow(new Date());
      intervalId = setInterval(() => setNow(new Date()), MINUTE_MS);
    }, msUntilNextMinute);

    return () => {
      clearTimeout(timeoutId);
      if (intervalId !== null) clearInterval(intervalId);
    };
  }, []);

  return <TimerContext.Provider value={now}>{children}</TimerContext.Provider>;
};

export const TimerProvider = memo(TimerProviderComponent);
